import { useQuery } from "react-query";
import { getOrganizationsForAdmin } from "./gateway";

export const useGetOrganizationsForAdmin = (enabled: boolean) => {
  return useQuery({
    queryFn: () => getOrganizationsForAdmin(),
    queryKey: ["getOrganizationsForAdmin", enabled],
    enabled,
  });
};
